import { createDeleteApi } from "@api/util/createDeleteApi";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  IProductBatchesGetAllParams,
  IProductBatchesResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IProductBatchesResponse>>,
  IPathBaseParam,
  IPaginationParams & IProductBatchesGetAllParams
>("stores.products.batches");

const getApis = createGetApi<
  IApiResponse<IProductBatchesResponse>,
  IPathByIdParam,
  object
>("stores.products.batches");

const deleteApis = createDeleteApi<
  IApiResponse<IProductBatchesResponse>,
  IPathByIdParam
>("stores.products.batches");

export const batches = {
  ...getAllApis,
  ...getApis,
  ...deleteApis,
};
